import { useEffect, useState } from "react";
import { Flex, ModalFooter, useToast } from "@chakra-ui/react";
import { Modal } from "../Modal";
import { Loading } from "../../shared/Loading";
import { ButtonCustom } from "../../form/controls/form.button";
import { FormInput } from "../../form/controls/form.input";
import { errorToast, successToast } from "../../../constants/toast.constants";
import { UserService } from "../../../service/user/user.service";

export const InviteUserModal = ({ isOpen, onClose, onSubmit }) => {
  const userService = new UserService();

  const toast = useToast();

  const [formState, setFormState] = useState({
    email: "",
  });
  const [loading, setLoading] = useState(false);

  const onInputChange = (event: any) => {
    let { name, value } = event.target;

    setFormState({
      ...formState,
      [name]: value,
    });
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    setLoading(true);

    await userService
      .invite(formState)
      .then(() => {
        onClose();
        toast(
          successToast(`${formState.email} has been successfully invited!`)
        );
      })
      .catch((err) => {
        toast(errorToast(`Something went wrong. Please try again.`));
      })
      .finally(() => {
        setLoading(false);
        if (onSubmit) onSubmit();
      });
  };

  const handleClose = () => {
    setFormState({
      email: "",
    });
    onClose();
  };

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <Modal isOpen={isOpen} header="Invite User" onClose={handleClose}>
      <Loading loading={loading} fill ignoreDelay />
      <form onSubmit={handleSubmit}>
        <Flex flexDir="column">
          <FormInput
            name="email"
            title="User Email"
            required
            type="email"
            placeholder="Enter user email address"
            onChange={onInputChange}
          />

          <ModalFooter>
            <Flex gap="12px">
              <ButtonCustom secondary neutral onClick={onClose}>
                Cancel
              </ButtonCustom>
              <ButtonCustom type="submit">Invite</ButtonCustom>
            </Flex>
          </ModalFooter>
        </Flex>
      </form>
    </Modal>
  );
};
